import { createSelector } from '@ngrx/store';
import { incomingFaxRegisterSelector } from './incoming-fax-register.reducer';

export const selectFilters = createSelector(incomingFaxRegisterSelector, (state) => {
   return state.filters;
});
export const selectOrderingOptions = createSelector(incomingFaxRegisterSelector, (state) => {
   return state.orderingOptions;
});
